import React from "react";

let clickHandle = event => {
  window.scroll({ top: 0, left: 0, behavior: "smooth" });
};

function index() {
  return (
    <footer className="bg-black" data-scroll-index="6">
      <div className="footer-bottom">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-sm-12 text-center">
              <span className="font-size13 text-uppercase letter-spacing-1 text-light-gray">
                &copy; 2019 Irfan G G
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        id="back-to-top"
        className="back-to-top reveal"
        onClick={clickHandle}
      >
        <i className="fa fa-angle-up" />
      </div>
    </footer>
  );
}

export default index;
